module.exports = {
	data() {
		return {
			scrollPos: 0,
			isGnavOpen: false,
			tabContentPos: null,
			currentTab: -1
		}
	},
	watch: {
		isGnavOpen(val) {
			this.onModalOpen(val)
		},
		scrollPos(val) {
			this.manageTabCurrent()
		}
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll)
		this.onScroll()

		// params
		this.manageParams()
		// pagelink
		this.managePagelink()
	},
	methods: {
		clickTo(to, offset = 0) {
			var target = 0;
			if(to!=='#') {
				var elm = document.getElementById(to);
				target = elm.getBoundingClientRect().top + window.pageYOffset - document.querySelector('.header').clientHeight
			}
			window.scroll({
				top: target - offset,
				behavior: "smooth"
			})
		},
		onScroll() {
			this.scrollPos = window.pageYOffset
		},
		onTriggerClick(evt) {
			this.isGnavOpen = !this.isGnavOpen
		},
		onModalOpen(val) {
			if(val) {
				document.body.classList.add('is-modal-open')
				document.addEventListener('touchmove', this.disableScroll, { passive: false });
			} else {
				document.body.classList.remove('is-modal-open')
				document.removeEventListener('touchmove', this.disableScroll)
			}
		},
		onTabClick(evt) {
			if(!evt.target.classList.contains('is-current')) {
				const target = evt.target
				const parent = target.parentElement
				const tabTarget = document.getElementById(parent.getAttribute('data-tab-target'))
				const contTarget = document.getElementById(target.getAttribute('data-target'))
				const offset = parent.getAttribute('data-offset')

				// tab
				parent.querySelector('.is-current').classList.remove('is-current')
				target.classList.add('is-current')

				// content
				tabTarget.querySelector('.is-current').classList.remove('is-current')
				contTarget.classList.add('is-current')

				this.clickTo(parent.getAttribute('id'), offset)
			}
		},
		onPageLinkClick(val, evt) {
			evt.preventDefault()
			const tabPos = document.querySelectorAll('.page-link-content');
			window.scroll({
				top: tabPos[val].getBoundingClientRect().top + window.pageYOffset - document.querySelector('.header').clientHeight - document.querySelector('.pagelink-primary').clientHeight,
				behavior: "smooth"
			})
		},
		onExtTabClick(evt) {
			evt.preventDefault()
			const scrollTop = window.scrollY
			window.location.href = evt.target.getAttribute('href') + '?scroll=' + window.scrollY
		},
		manageParams() {
			let queryString = document.location.search
			var queryObject = new Object()
			if(queryString){
				queryString = queryString.substring(1)
				var parameters = queryString.split('&')
				for (var i = 0; i < parameters.length; i++) {
					var element = parameters[i].split('=')
					var paramName = decodeURIComponent(element[0])
					var paramValue = decodeURIComponent(element[1])
					queryObject[paramName] = paramValue
				}
			}
			if(queryObject.scroll > 0) {
				window.scroll({
					top: queryObject.scroll,
					behavior: "instant"
				})
			}
		},
		managePagelink() {
			const contents = document.querySelectorAll('.page-link-content')
			const pos = []
			contents.forEach((item, index) => {
				pos[index] = item.getBoundingClientRect().top + window.pageYOffset - document.querySelector('.header').clientHeight - document.querySelector('.pagelink-primary').clientHeight
			})
			this.tabContentPos = pos
		},
		manageTabCurrent() {
			if(document.querySelector('.pagelink-primary')) {
				this.currentTab = -1
				for(var i = 0; i < this.tabContentPos.length; i++) {
					if(this.scrollPos > this.tabContentPos[i] - window.innerHeight * .25) {
						this.currentTab = i
					}
				}
			}
		}
	}
}
